const CRAWLER_USER_AGENT_PATTERNS: RegExp[] = [
  /googlebot/i,
  /google-inspectiontool/i,
  /bingbot/i,
  /duckduckbot/i,
  /slurp/i,
  /applebot/i,
  /yandexbot/i,
  /baiduspider/i,
  /facebot/i,
  /facebookexternalhit/i,
  /twitterbot/i,
  /linkedinbot/i,
  /pinterestbot/i,
  /ahrefsbot/i,
  /semrushbot/i,
  /screaming frog/i,
  /gptbot/i,
  /chatgpt-user/i,
  /oai-searchbot/i,
  /ccbot/i,
  /claudebot/i,
  /anthropic-ai/i,
  /perplexitybot/i,
  /bytespider/i,
]

export const isCrawlerUserAgent = (userAgent: unknown): boolean => {
  if (typeof userAgent !== "string") return false
  const normalized = userAgent.trim()
  if (!normalized) return false
  return CRAWLER_USER_AGENT_PATTERNS.some((pattern) => pattern.test(normalized))
}

export const resolveClientUserAgent = (): string => {
  if (typeof navigator === "undefined") return ""
  return typeof navigator.userAgent === "string" ? navigator.userAgent : ""
}

export const isCrawlerClientRequest = (): boolean => {
  return isCrawlerUserAgent(resolveClientUserAgent())
}

